var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h2", [_vm._v("Instagram Service")]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          " Your instagram integration is completed. You can now use the service. "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mt-5" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }